// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tn-search {
  position: fixed;
  inset: 0;
  background: rgba(10, 22, 40, 0.55);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 80px 20px 20px;
  z-index: 11500;
  animation: tn-search-fade 0.15s ease-out;
}

@keyframes tn-search-fade { from { opacity: 0; } to { opacity: 1; } }

.tn-search__card {
  width: 100%;
  max-width: 560px;
  background: #fff;
  color: #1f2937;
  border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  overflow: hidden;
  animation: tn-search-rise 0.18s ease-out;
}

@keyframes tn-search-rise {
  from { transform: translateY(8px); opacity: 0; }
  to   { transform: translateY(0);   opacity: 1; }
}

.tn-search__inputrow {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid #e5e7eb;
}

.tn-search__icon {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #6b7280;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 4px 7px;
  border-radius: 4px;
}

.tn-search__input {
  flex: 1 1;
  border: none;
  outline: none;
  font-family: inherit;
  font-size: 15px;
  background: transparent;
  color: #111827;
}

.tn-search__close {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 0 6px;
}

.tn-search__close:hover { color: #111827; }

.tn-search__results {
  list-style: none;
  margin: 0;
  padding: 6px;
  max-height: min(420px, 60vh);
  overflow-y: auto;
}

.tn-search__item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  align-items: baseline;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.tn-search__item.is-active { background: rgba(0, 168, 150, 0.08); }
.tn-search__item:hover     { background: rgba(0, 168, 150, 0.06); }

.tn-search__kind {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: #fff;
  border-radius: 4px;
  padding: 2px 6px;
  background: #6b7280;
}

.tn-search__kind--route { background: #001F3F; }
.tn-search__kind--blog  { background: #00a896; }

.tn-search__title { font-weight: 500; color: #111827; }
.tn-search__hint  { font-size: 11px; color: #6b7280; }

.tn-search__empty {
  padding: 18px 12px;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}

.tn-search__foot {
  display: flex;
  gap: 14px;
  justify-content: flex-end;
  padding: 8px 14px;
  border-top: 1px solid #e5e7eb;
  font-size: 11px;
  color: #6b7280;
}

.tn-search__foot kbd {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-bottom-width: 2px;
  border-radius: 3px;
  padding: 1px 5px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: #374151;
}

@media (prefers-reduced-motion: reduce) {
  .tn-search,
  .tn-search__card { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteSearch/SiteSearch.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,4BAA4B,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAEpE;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,+EAA+E;EAC/E,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,OAAO,0BAA0B,EAAE,UAAU,EAAE;EAC/C,OAAO,wBAAwB,IAAI,UAAU,EAAE;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,0BAA0B,cAAc,EAAE;;AAE1C;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,6BAA6B,mCAAmC,EAAE;AAClE,6BAA6B,mCAAmC,EAAE;;AAElE;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;;AAE/C,oBAAoB,gBAAgB,EAAE,cAAc,EAAE;AACtD,oBAAoB,eAAe,EAAE,cAAc,EAAE;;AAErD;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;qBACmB,eAAe,EAAE;AACtC","sourcesContent":[".tn-search {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 22, 40, 0.55);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 80px 20px 20px;\n  z-index: 11500;\n  animation: tn-search-fade 0.15s ease-out;\n}\n\n@keyframes tn-search-fade { from { opacity: 0; } to { opacity: 1; } }\n\n.tn-search__card {\n  width: 100%;\n  max-width: 560px;\n  background: #fff;\n  color: #1f2937;\n  border-radius: 12px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  overflow: hidden;\n  animation: tn-search-rise 0.18s ease-out;\n}\n\n@keyframes tn-search-rise {\n  from { transform: translateY(8px); opacity: 0; }\n  to   { transform: translateY(0);   opacity: 1; }\n}\n\n.tn-search__inputrow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.tn-search__icon {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: #6b7280;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  padding: 4px 7px;\n  border-radius: 4px;\n}\n\n.tn-search__input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-family: inherit;\n  font-size: 15px;\n  background: transparent;\n  color: #111827;\n}\n\n.tn-search__close {\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 6px;\n}\n\n.tn-search__close:hover { color: #111827; }\n\n.tn-search__results {\n  list-style: none;\n  margin: 0;\n  padding: 6px;\n  max-height: min(420px, 60vh);\n  overflow-y: auto;\n}\n\n.tn-search__item {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 12px;\n  align-items: baseline;\n  padding: 10px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.tn-search__item.is-active { background: rgba(0, 168, 150, 0.08); }\n.tn-search__item:hover     { background: rgba(0, 168, 150, 0.06); }\n\n.tn-search__kind {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  color: #fff;\n  border-radius: 4px;\n  padding: 2px 6px;\n  background: #6b7280;\n}\n\n.tn-search__kind--route { background: #001F3F; }\n.tn-search__kind--blog  { background: #00a896; }\n\n.tn-search__title { font-weight: 500; color: #111827; }\n.tn-search__hint  { font-size: 11px; color: #6b7280; }\n\n.tn-search__empty {\n  padding: 18px 12px;\n  font-size: 13px;\n  color: #6b7280;\n  text-align: center;\n}\n\n.tn-search__foot {\n  display: flex;\n  gap: 14px;\n  justify-content: flex-end;\n  padding: 8px 14px;\n  border-top: 1px solid #e5e7eb;\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.tn-search__foot kbd {\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-bottom-width: 2px;\n  border-radius: 3px;\n  padding: 1px 5px;\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 10px;\n  color: #374151;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .tn-search,\n  .tn-search__card { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
